
/*
 |--------------------------------------------------------------------------
 | Laravel Spark Bootstrap
 |--------------------------------------------------------------------------
 |
 | First, we will load all of the "core" dependencies for Spark which are
 | libraries such as Vue and jQuery. This also loads the Spark helpers
 | for things such as HTTP calls, forms, and form validation errors.
 |
 | Next, we'll create the root Vue application for Spark. This will start
 | the entire application and attach it to the DOM. Of course, you may
 | customize this script as you desire and load your own components.
 |
 */

require('spark-bootstrap');
require('./components/bootstrap');
require('./components/kendo')
require('./ashnet-components/bootstrap');



import { flare } from "@flareapp/flare-client";
import { flareVue } from "@flareapp/flare-vue";

/* Sentry */
/*
import * as Sentry from "@sentry/vue";
Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
});
*/


// only launch in production, we don't want to waste your quota while you're developing.
if (process.env.NODE_ENV === 'production') {
    flare.light(window.AshnetApp.flareJsKey);
}

import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';

import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';

import { required, email} from 'vee-validate/dist/rules';




import {MediaLibraryAttachment} from "@spatie/media-library-pro-vue2-attachment";
import {MediaLibraryCollection} from "@spatie/media-library-pro-vue2-collection";


//import gridLangDe from 'grid-lang-de/src/custom.locale.De';
//import schedulerLangDe from 'scheduler-pro-lang-de/src/custom.locale.De';


import 'moment/moment'
import 'moment-timezone'
import 'daterangepicker/daterangepicker'

import swal from 'sweetalert2';


import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import {i18n} from "./i18Instance";

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');

window.Vue = require('vue');
window.JSZip = require('jszip');


/** axios error interceptor
 *
 *
 */
import axios from 'axios';

axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response.status === 401) {
            console.error("Global ajax interceptor - 401");
            window.location = '/logout';
        }
        return Promise.reject(error);
    }
);




/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.use(flareVue);
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(require('vue-shortkey'));
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.use(VueFormWizard);

Vue.use(Loading);


// Attention - Apply this mixin only after "Vue.use(VueRouter);"
import handleBackMixin from "./handle-back";
Vue.mixin(handleBackMixin);

const store = new Vuex.Store({
    state: {
        gridOptions:{
            rmsObjectMain: {
                default:{},
                current:{}
            }
        }
    },
    plugins: [createPersistedState(
        {
            key: 'ashrms'
        }
    )],
    mutations: {
        // RmsObjects Grid
        SetRmsObjectGridCurrentOptions(state, payload){
            state.gridOptions.rmsObjectMain.current = payload;
        },
        SetRmsObjectGridDefaultOptions(state, payload){
            state.gridOptions.rmsObjectMain.default = payload;
        },
    },
    getters:{}
});

var mainStore = {
    debug: true,
    state: {
        message: '.',
        importdata: {
            raw: null,
            prepared: null
        },
    },

    setMessageAction (newValue) {
        if (this.debug) console.log('setMessageAction triggered with', newValue);
        this.state.message = newValue
    },
    clearMessageAction () {
        if (this.debug) console.log('clearMessageAction triggered');
        this.state.message = ''
    }
}

const lazyDashboardComponent = () => import('./ashnet-components/dashboard/dashboard.vue')
const lazyCalendarComponent = () => import('./ashnet-components/calendar/calendarbr.vue');
const lazyImportGridComponent = () => import('./ashnet-components/import/import-objects-grid.vue');
const lazyRmsObjectsComponent = () => import('./ashnet-components/rmsobjects/rms-objects-grid.vue');
const lazyOrdersComponent = () => import('./ashnet-components/orders/orders-grid.vue');
const lazyRequestsComponent = () => import('./ashnet-components/request/requests-grid.vue');
const lazyCustomersComponent = () => import('./ashnet-components/customers/customers-grid.vue');



const routes = [
    {
        path: '/dashboard',
        name: 'dashboard',
        component: lazyDashboardComponent,
        props: true,
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/calendar',
        name: 'calendar',
        component: lazyCalendarComponent,
        props: true,
        meta: {
            keepAlive: true
        },
        beforeEnter: (to, from, next) => {
            if(!AshnetApp.can("orders read")){
                swal.fire({
                    text: "Unauthorized access",
                    icon: "error",
                    timer: 1000
                });
                next({
                    path: '/',
                    replace: true
                });
                return false;
            }else{
                next();
            }
        },
    },
    {
        path: '/objects-create',
        name: 'objects-create',
        component: Vue.component('form-rms-object'),
        props: true,
        meta: {
            keepAlive: false
        },
        beforeEnter: (to, from, next) => {
            if(!AshnetApp.can("equipment create")){
                swal.fire({
                    text: "Unauthorized access",
                    icon: "error",
                    timer: 1000
                });
                next({
                    path: '/',
                    replace: true
                });
                return false;
            }else{
                next();
            }
        },
    },
    {
        path: '/objects-edit/:rmsobjectid',
        name: 'objects-edit',
        component: Vue.component('form-rms-object'),
        props: (route) => ({
            mode: 'edit',
            rmsobjectid: Number(route.params.rmsobjectid)
        }),
        meta: {
            keepAlive: false
        },
        beforeEnter: (to, from, next) => {
            if(!AshnetApp.can("equipment update")){
                swal.fire({
                    text: "Unauthorized access",
                    icon: "error",
                    timer: 1000
                });
                next({
                    path: '/',
                    replace: true
                });
                return false;
            }else{
                next();
            }
        },
    },
    {
        path: '/objects-details/:rmsobjectid',
        name: 'objects-details',
        component: Vue.component('rms-objects-detail'),
        props: (route) => ({
            mode: 'display',
            rmsobjectid: Number(route.params.rmsobjectid)
        }),
        meta: {
            keepAlive: false
        },
        beforeEnter: (to, from, next) => {
            if(!AshnetApp.can("equipment read")){
                swal.fire({
                    text: "Unauthorized access",
                    icon: "error",
                    timer: 1000
                });
                next({
                    path: '/',
                    replace: true
                });
                return false;
            }else{
                next();
            }
        },
    },
    {
        path: '/import-grid',
        name: 'import-grid',
        component: lazyImportGridComponent,
        props: true,
        meta: {
            keepAlive: true
        },
        beforeEnter: (to, from, next) => {
            if(!AshnetApp.can("equipment read")){
                swal.fire({
                    text: "Unauthorized access",
                    icon: "error",
                    timer: 1000
                });
                next({
                    path: '/',
                    replace: true
                });
                return false;
            }else{
                next();
            }
        },
    },
    {
        path: '/objects-grid',
        name: 'objects-grid',
        component: lazyRmsObjectsComponent,
        props: true,
        meta: {
            keepAlive: true
        },
        beforeEnter: (to, from, next) => {
            if(!AshnetApp.can("equipment read")){
                swal.fire({
                    text: "Unauthorized access",
                    icon: "error",
                    timer: 1000
                });
                next({
                    path: '/',
                    replace: true
                });
                return false;
            }else{
                next();
            }
        },
    },
    {
        path: '/order-display/:orderid',
        name: 'order-display',
        component: Vue.component('order-display'),
        props: (route) => ({
            mode: 'display',
            orderid: Number(route.params.orderid),
            context: route.params.context
        }),
        //props: (route) => ({ orderid: Number(route.params.orderid) }),
        meta: {
            keepAlive: false
        },
        beforeEnter: (to, from, next) => {
            if(!AshnetApp.can("orders read")){
                swal.fire({
                    text: "Unauthorized access",
                    icon: "error",
                    timer: 1000
                });
                next({
                    path: '/',
                    replace: true
                });
                return false;
            }else{
                next();
            }
        },
    },
    {
        path: '/order-create',
        name: 'order-create',
        component: Vue.component('order-create'),
        props: true,
        //props: (route) => ({ orderid: Number(route.params.orderid) }),
        meta: {
            keepAlive: false
        },
        beforeEnter: (to, from, next) => {
            if(!AshnetApp.can("orders create")){
                swal.fire({
                    text: "Unauthorized access",
                    icon: "error",
                    timer: 1000
                });
                next({
                    path: '/',
                    replace: true
                });
                return false;
            }else{
                next();
            }
        },
    },
    {
        path: '/order-edit/:orderid',
        name: 'order-edit',
        component: Vue.component('order-edit'),
        props: (route) => ({
            mode: 'edit',
            orderid: Number(route.params.orderid),
            context: route.params.context
        }),
        meta: {
            keepAlive: false
        },
        beforeEnter: (to, from, next) => {
            if(!AshnetApp.can("orders update")){
                swal.fire({
                    text: "Unauthorized access",
                    icon: "error",
                    timer: 1000
                });
                next({
                    path: '/',
                    replace: true
                });
                return false;
            }else{
                next();
            }
        },
    },
    {
        path: '/order-checkin/:orderid',
        name: 'order-checkin',
        component: Vue.component('order-edit'),
        props: (route) => ({
            mode: route.params.mode,
            formdisabled: route.params.formdisabled,
            orderid: Number(route.params.orderid),
            context: route.params.context
        }),
        meta: {
            keepAlive: false
        },
        beforeEnter: (to, from, next) => {
            if(!AshnetApp.can("orders update")){
                swal.fire({
                    text: "Unauthorized access",
                    icon: "error",
                    timer: 1000
                });
                next({
                    path: '/',
                    replace: true
                });
                return false;
            }else{
                next();
            }
        },
    },
    {
        path: '/order-checkout/:orderid',
        name: 'order-checkout',
        component: Vue.component('order-edit'),
        props: (route) => ({
            mode: route.params.mode,
            formdisabled: route.params.formdisabled,
            orderid: Number(route.params.orderid),
            context: route.params.context
        }),
        meta: {
            keepAlive: false
        },
        beforeEnter: (to, from, next) => {
            if(!AshnetApp.can("orders update")){
                swal.fire({
                    text: "Unauthorized access",
                    icon: "error",
                    timer: 1000
                });
                next({
                    path: '/',
                    replace: true
                });
                return false;
            }else{
                next();
            }
        },
    },
    {
        path: '/orders-grid',
        name: 'orders-grid',
        component: lazyOrdersComponent,
        props: true,
        meta: {
            keepAlive: false
        },
        beforeEnter: (to, from, next) => {
            if(!AshnetApp.can("orders delete")){
                swal.fire({
                    text: "Unauthorized access",
                    icon: "error",
                    timer: 1000
                });
                next({
                    path: '/',
                    replace: true
                });
                return false;
            }else{
                next();
            }
        },
    },
    {
        path: '/requests-grid',
        name: 'requests-grid',
        component: lazyRequestsComponent,
        props: true,
        meta: {
            keepAlive: false
        },
        beforeEnter: (to, from, next) => {
            if(!AshnetApp.can("requests create")){
                swal.fire({
                    text: "Unauthorized access",
                    icon: "error",
                    timer: 1000
                });
                next({
                    path: '/',
                    replace: true
                });
                return false;
            }else{
                next();
            }
        },
    },
    {
        path: '/request-create',
        name: 'request-create',
        component: Vue.component('request-create'),
        props: (route) => ({
            mode: route.params.mode,
            orderid: Number(route.params.orderid),
            context: route.params.context
        }),
        meta: {
            keepAlive: false
        },
        beforeEnter: (to, from, next) => {
            if(!AshnetApp.can("requests create")){
                swal.fire({
                    text: "Unauthorized access",
                    icon: "error",
                    timer: 1000
                });
                next({
                    path: '/',
                    replace: true
                });
                return false;
            }else{
                next();
            }
        },
    },
    {
        path: '/request-approve/:orderid',
        name: 'request-approve',
        component: Vue.component('form-approve'),
        props: (route) => ({
            mode: 'approval',
            orderid: Number(route.params.orderid),
            context: route.params.context
        }),
        meta: {
            keepAlive: false
        },
        beforeEnter: (to, from, next) => {
            if(!AshnetApp.can("requests manage all")){
                swal.fire({
                    text: "Unauthorized access",
                    icon: "error",
                    timer: 1000
                });
                next({
                    path: '/',
                    replace: true
                });
                return false;
            }else{
                next();
            }
        },
    },
    {
        path: '/contacts-grid',
        name: 'contacts-grid',
        component: lazyCustomersComponent,
        props: true,
        meta: {
            keepAlive: false
        },
        beforeEnter: (to, from, next) => {
            if(!AshnetApp.can("customers delete")){
                swal.fire({
                    text: "Unauthorized access",
                    icon: "error",
                    timer: 1000
                });
                next({
                    path: '/',
                    replace: true
                });
                return false;
            }else{
                next();
            }
        },
    },
    {
        path: '/contact-display/:customerid',
        name: 'contact-display',
        component: Vue.component('form-customer'),
        props: (route) => ({
            mode: 'display',
            formdisabled: true,
            customerid: Number(route.params.customerid),
            context: route.params.context
        }),
        //props: (route) => ({ orderid: Number(route.params.orderid) }),
        meta: {
            keepAlive: false
        },
        beforeEnter: (to, from, next) => {
            if(!AshnetApp.can("customers read")){
                swal.fire({
                    text: "Unauthorized access",
                    icon: "error",
                    timer: 1000
                });
                next({
                    path: '/',
                    replace: true
                });
                return false;
            }else{
                next();
            }
        },
    },
    {
        path: '/contact-create',
        name: 'contact-create',
        component: Vue.component('form-customer'),
        props: true,
        meta: {
            keepAlive: false
        },
        beforeEnter: (to, from, next) => {
            if(!AshnetApp.can("customers create")){
                swal.fire({
                    text: "Unauthorized access",
                    icon: "error",
                    timer: 1000
                });
                next({
                    path: '/',
                    replace: true
                });
                return false;
            }else{
                next();
            }
        },
    },
    {
        path: '/contact-edit/:customerid',
        name: 'contact-edit',
        component: Vue.component('form-customer'),
        props: (route) => ({
            mode: 'edit',
            customerid: Number(route.params.customerid),
            context: route.params.context
        }),
        //props: (route) => ({ orderid: Number(route.params.orderid) }),
        meta: {
            keepAlive: false
        },
        beforeEnter: (to, from, next) => {
            if(!AshnetApp.can("customers update")){
                swal.fire({
                    text: "Unauthorized access",
                    icon: "error",
                    timer: 1000
                });
                next({
                    path: '/',
                    replace: true
                });
                return false;
            }else{
                next();
            }
        },
    },
    {
        path: '/statistics',
        name: 'statistics',
        component: Vue.component('statistics-home'),
        props: true,
        meta: {
            keepAlive: false
        },
        beforeEnter: (to, from, next) => {
            if(!AshnetApp.can("statistics read")){
                swal.fire({
                    text: "Unauthorized access",
                    icon: "error",
                    timer: 1000
                });
                next({
                    path: '/',
                    replace: true
                });
                return false;
            }else{
                next();
            }
        },
    },
    {
        path: '/privacy-policy',
        name: 'privacy-policy',
        component: Vue.component('privacy-policy'),
        props: true,
        meta: {
            keepAlive: false
        }
    },
    {
        // will match empty page
        path: '/',
        redirect: 'dashboard'
    },
    {
        // will match other pages
        path: '*',
        redirect: 'dashboard'
    }
]


const router = new VueRouter({
    routes // short for `routes: routes`
})

var app = new Vue({
    mixins: [require('spark')],
    i18n,
    router,
	data: {
        privateState: {},
        sharedState: mainStore.state
    },
    store,
    components: {
        MediaLibraryAttachment,
        MediaLibraryCollection
    }
});
console.log("vueApp",app);
console.log("data:",app.sharedState);

// Translations hinzufügen für Vee-Validate

extend('required', {
    ...required,
    message: app.$t('requestpage.field-required')
});

extend('email', {
    ...email,
    message: app.$t('requestpage.email-invalid')
});
